export default "__VITE_ASSET__pDXBMC96__"